import { Card, Heading, HeadingGroup, Subheading } from './SubSelectCard.styles';
import type { SubSelectCardProps } from './SubSelectCard.types';

export function SubSelectCard({ heading, subheading, children, className }: SubSelectCardProps) {
  return (
    <Card className={className}>
      {heading &&
        (subheading ? (
          <HeadingGroup>
            <Heading>{heading}</Heading>
            <Subheading>{subheading}</Subheading>
          </HeadingGroup>
        ) : (
          <Heading>{heading}</Heading>
        ))}
      {children}
    </Card>
  );
}
